import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_8738e3dd-1e34-4ed5-b195-7b188c06ef47/artifacts/1o02hvfb_1072380-custom_site_themes-id-xg8wb43iQreBGWHGPU1z_Screenshot_20250404_200718_Chrome.jpg";

const Footer = () => {
  return (
    <footer className="gradient-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="bg-white/10 backdrop-blur rounded-lg p-3 w-fit mb-4">
              <img src={LOGO_URL} alt="Capital Clarity Academy" className="h-10 w-auto" />
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              Empowering financial understanding through expert-led courses and digital resources.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/courses" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm">
                  Courses
                </Link>
              </li>
              <li>
                <Link to="/downloads" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm">
                  Digital Downloads
                </Link>
              </li>
              <li>
                <Link to="/cart" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm">
                  Shopping Cart
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Categories</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/courses?category=Personal%20Finance" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm">
                  Personal Finance
                </Link>
              </li>
              <li>
                <Link to="/courses?category=Investing" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm">
                  Investing
                </Link>
              </li>
              <li>
                <Link to="/courses?category=Business%20Finance" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm">
                  Business Finance
                </Link>
              </li>
              <li>
                <Link to="/downloads?category=Templates" className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm">
                  Templates
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-white/70 text-sm">
                <Mail className="w-4 h-4 text-[#D4AF37]" />
                support@capitalclarity.academy
              </li>
              <li className="flex items-center gap-3 text-white/70 text-sm">
                <Phone className="w-4 h-4 text-[#D4AF37]" />
                212.220.8708
              </li>
              <li className="flex items-start gap-3 text-white/70 text-sm">
                <MapPin className="w-4 h-4 text-[#D4AF37] mt-0.5" />
                1 World Trade Center<br />Fl 85<br />New York, NY 10007
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} Capital Clarity S-Corp. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-white/50 hover:text-white text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-white/50 hover:text-white text-sm transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
